export default {
  off: 'cancelled',
  pending: 'awaiting patient',
  inprogress: 'awaiting clinician',
  success: 'completed',
};
